
let _isTransitioning: boolean = false;

/**
 * For fixing SOFA-2671
 */
export function isTransitioning(): boolean {
    return _isTransitioning;
}

export function setIsTransitioning(val: boolean): void {
    _isTransitioning = val;
}
